import services from "@/services";
import moment from "moment";
import filters from "@/filter";

const state = {
  products: [],
  product: {},
  itemsProduct: [],
  itemsPromo: [],
  itemsPromoFilter: [],
  categoryProduct: {},
  successInput: false,
};
const getters = {
  categoryProductItems: (state) => {
    let groupProduct = state.itemsProduct?.map((x) => {
      x.level_label = x.level === 1 ? "CATEGORY" : "SUB CATEGORY";
      x.parent_name = x.parent_category_name;
      x.actions = {
        id: x.id,
        url: `category-product/edit-category/${x.parent_category_id? x.parent_category_id : x.id}`,
        edit: "enable",
        delete: x.product_count > 0 ? "disable" : "enable",
      };
      return x;
    });
    return groupProduct;
  },
  parentProductItems: (state) => {
    let parentProduct = state.itemsProduct.filter((x) => {
      return x.level == 1;
    });
    return parentProduct;
  },
  childProductItems: (state) => (parentID) => {
    if(!state?.itemsProduct?.length) return []
    let childProduct = state.itemsProduct.filter((x) => {
      return x.parent_category_id == parentID && x.level == 2;
    });
    return childProduct;
  },
  getProduct: (state) => {
    let status = ''
    switch (state.product.product.product_status) {
      case 'Published':
        if(state.product.product.stock_current > 0){
          status = "Live In Stock"
        }else{
          status = "Live Out of Stock"
        }
        break;
      case 'Trashed':
        status = "Archive"
        break;
      case 'Suspended':
        status = 'Suspended'
        break;
      case 'NeedReview':
        status = 'Need Review'
        break;
      case 'Archive':
        status = 'Archive'
        break;
      default:
        break;
    }
    const product = {
      id: state.product.product.id,
      name: state.product.product.name,
      image_url: filters.imageParse(state.product.product.image_url),
      price_displayed: state.product.product.price_displayed,
      price_regular: state.product.product.price_regular,
      price_sale: state.product.product.price_sale,
      stock_current: state.product.product.stock_current,
      product_status: state.product.product.product_status,
      is_variant: state.product.product.is_variant,
      status : status,
      action: {
        id: state.product.product.id,
        delete: "enable",
      },
    };

    return product;
  },
  categoryPromoItems: (state) => {
    if (state.itemsPromo) {
      let res = state.itemsPromo.map((x) => {
        x.created_date = moment(x.created_date).format("DD MMM YYYY");
        x.date_start = x.date_start != '0001-01-01T00:00:00Z' ? moment(x.date_start).format("DD MMM YYYY") : "";
        x.date_end = x.date_end != '0001-01-01T00:00:00Z' ? moment(x.date_end).format("DD MMM YYYY") : "";
        x.actions = {
          id: x.id,
          url: `category-promo/edit/${x.id}`,
          edit: "enable",
          delete: "enable",
        };
        return x;
      });
      return res;
    } else {
      return [];
    }
  },
  productItems: (state) => {
    let products = !state.products
      ? []
      : state.products.map((x) => {
          let actionsSecondary = [];
          x.actions = {
            id: x.id,
            url: `detail/${x.id}`,
            edit: "enable",
          };
          x.additional_row = false;
          x.created_date = moment(x?.created_date).format("DD MMM YYYY - HH:mm");
          x.updated_date = moment(x?.updated_date).format("DD MMM YYYY - HH:mm");
          switch (x.product_status) {
            case (x.product_status = "Published"):
              actionsSecondary = [
                {
                  label: "Archive",
                  status: "Archive",
                },
                {
                  label: "Suspend",
                  status: "Suspended",
                },
              ];
              break;
            case (x.product_status = "Archive"):
              actionsSecondary = [
                {
                  label: "Live",
                  status: "Published",
                },
                {
                  label: "Suspend",
                  status: "Suspended",
                },
              ];
              break;
            case (x.product_status = "Suspended"):
              actionsSecondary = [
                {
                  label: "Live",
                  status: "Published",
                },
                {
                  label: "Archive",
                  status: "Archive",
                },
              ];
              break;
            case (x.product_status = "NeedReview"):
              actionsSecondary = [
                {
                  label: "Live",
                  status: "Published",
                },
                {
                  label: "Resuspend",
                  status: "Unsuspend",
                },
              ];
              break;
            default:
              break;
          }
          x.actionsSecondary = actionsSecondary;
          x.variant = x.is_variant ? "VARIANT" : "SIMPLE";
          x.listVariant = x.product_variants;
          x.image_url = filters.imageParse(x.image_url)
          return x;
        });
    return products;
  },
};

const mutations = {
  setCategoryProductItems: (state, items) => {
    state.itemsProduct = items;
  },
  setCategoryProduct: (state, data) => {
    state.categoryProduct = data;
  },
  setCategoryPromoItem: (state, items) => {
    state.itemsPromo = items;
  },
  setCategoryPromofilter: (state, items) => {
    state.itemsPromoFilter = items;
  },
  setProductItems: (state, items) => {
    state.products = items;
  },
  setProduct: (state, product) => {
    state.product = product;
  },
  setStatusSubmit: (state, status) => {
    state.successInput = status;
  },
};

const actions = {
  getAllProduct({ commit, dispatch }, param) {
    dispatch('setLoadingTable', true, { root: true })
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("product", param)
        .then((response) => {
          commit("setProductItems", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          dispatch('setLoadingTable', false, { root: true })
        })
    });
  },
  getOneProduct({ commit, dispatch }, id) {
    services.setHeader();
    dispatch('setLoadingGlobal', true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("product/" + id)
        .then((response) => {
          commit("setProduct", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          dispatch('setLoadingGlobal', false, { root: true })
        })
    });
  },
  getOneProductReview({ commit, dispatch }, id) {
    services.setHeader();
    dispatch('setLoadingGlobal', true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("productonreview/" + id)
        .then((response) => {
          commit("setProduct", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          dispatch('setLoadingGlobal', false, { root: true })
        })
    });
  },
  updateProduct({ commit, dispatch }, body) {
    services.setHeader();
    dispatch('setLoadingGlobal', true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("product/" + body.id, body)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          dispatch('setLoadingGlobal', false, { root: true })
        })
    });
  },
  updateStatusProduct({ commit }, body) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .put("product/" + body.id + "/status", body)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusBulkProduct({ commit }, body) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .put("product/bulkstatus", body)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusOnReviewProduct({ commit }, body) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .put("productonreview/" + body.id + "/status", body)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusOnReviewBulkProduct({ commit }, body) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .put("productonreview/bulkstatus", body)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllCategoryProduct({ commit, dispatch }, param) {
    if(!param.noLoading){
      dispatch('setLoadingTable', true, { root: true })
    }
    delete param.noLoading
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("categoryproduct", param)
        .then((response) => {
          commit("setCategoryProductItems", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch('setLoadingTable', false, { root: true })
        })
    });
  },
  getAllProductByCategory({ commit }, categoryId) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get(`productcategory/${categoryId}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetailCategoryProduct({ commit }, id) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("categoryproduct/" + id)
        .then((response) => {
          commit("setCategoryProduct", response.data.data.item);
          resolve(response.data.data.item);
        })
        .catch((error) => {
          reject(error);
        })
    });
  },
  createCategoryProduct({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch('setLoadingGlobal', true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("categoryproduct", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          dispatch('setLoadingGlobal', false, { root: true })
        })
    });
  },
  updateCategoryProduct({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch('setLoadingGlobal', true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("categoryproduct/", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          dispatch('setLoadingGlobal', false, { root: true })
        })
    });
  },
  deleteCategoryProduct({ commit, dispatch }, id) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .delete("categoryproduct/" + id)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  deleteCategoryPromo({ commit, dispatch }, id) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .delete("categorypromo/" + id)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  transferCategoryProduct({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("producttransfer", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  getAllCategoryPromo({ commit, dispatch }, param) {
    services.setHeader();
    dispatch("setLoadingTable", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("categorypromo", param)
        .then((response) => {
          commit("setCategoryPromoItem", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingTable", false, { root: true })
        })
    });
  },
  getAllCategoryPromoFilter({ commit }, param) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("categorypromofilter", param)
        .then((response) => {
          commit("setCategoryPromofilter", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createFilterCategoryPromo({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("categorypromofilter", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  createCategoryPromo({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("categorypromo", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  updateCategoryPromo({ commit, dispatch }, body) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("categorypromo/" + body.id, body.payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  productSearch({ commit }, param) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("productsuggestion", param)
        .then((response) => {
          commit("setProductItems", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
